import Reflux from 'reflux';

const actions = Reflux.createActions({
	// items
	loadItem: {asyncResult: true},
	loadItems: {asyncResult: true},
	loadItemsDone: {},
	loadFacets: {asyncResult: true},
	facetsLoaded: {},
	loadItemSheet: {},

	// accessories
	loadAccessory: {asyncResult: true},
	loadAccessories: {asyncResult: true},
	loadAccessoriesDone: {},
	loadAccessoryIdsForItems: {asyncResult: true}, // special action for accessories
	loadAccessoryFacets: {asyncResult: true},
	accessoryFacetsLoaded: {},
	loadAccessorySheet: {},

	selectProperty: {},
	selectProperties: {},

	// general
	initializeMounting: {},
	changeConfiguration: {},

	windowResize: {},

	miLoading: {},
	miLoadingDone: {}
});

export default actions;
